module.exports = __webpack_public_path__ + "static/media/ic_refresh.8ee2970a.svg";